(() => {
  // Reuse only within this page; a new page load always reads current product metadata.
  const pageRequests = window.kenjoFinderPageRequests || (window.kenjoFinderPageRequests = new Map());
  function readPage(url, selector, timeout) {
    const key = url.href + '|' + selector;
    if (!pageRequests.has(key)) {
      const request = (async () => {
        const response = await fetch(url, {credentials:'same-origin',signal:AbortSignal.timeout(timeout)});
        if (!response.ok) throw new Error('Finder data unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = page.querySelector(selector);
        if (!node) throw new Error('Finder data missing');
        return JSON.parse(node.textContent);
      })().catch(error => { pageRequests.delete(key); throw error; });
      pageRequests.set(key,request);
    }
    return pageRequests.get(key);
  }
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const collectionKey = value => normal(value) === 'helmets' ? 'helmen' : normal(value);
  const list = value => Array.isArray(value) ? value : value ? [value] : [];
  const unique = values => [...new Map(values.map(value => [String(value.id), value])).values()];
  const nameSort = (a, b) => a.title.localeCompare(b.title, 'nl');
  const sideOf = value => /light side|\bjedi\b/i.test(value || '') ? 'light' : /dark side|\bsith\b/i.test(value || '') ? 'dark' : /overige/i.test(value || '') ? 'other' : /fantasie|custom/i.test(value || '') ? 'custom' : '';
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
  const cleanStory = value => normal(value).replace(/star wars:?\s*/g, '').replace(/seriecollectie/g, '').replace(/\bthe\b/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const roman = ['','i','ii','iii','iv','v','vi','vii','viii','ix'];
  function storyMatch(story, product) {
    return list(product.stories).some(value => {
      if (story.group === 'films') return normal(value).startsWith(roman[Number(story.episode)] + ' - ');
      if (story.group === 'games') return story.handle.includes('fallen-order') ? /fallen order|survivor/i.test(value) : normal(value) === 'overig';
      return cleanStory(story.title) === cleanStory(value);
    });
  }
  async function init(root) {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    const config = JSON.parse(root.querySelector('[data-finder-config]').textContent);
    const labels = config.labels;
    const sharedPreviews = new Set();
    const primaryCharacters = new Map();
    const isSharedPreview = product => sharedPreviews.has(product.handle);
    function characterFor(raw) {
      const name = String(raw).trim();
      if (!name || ['fantasy/customkarakter','fantasy','customkarakter'].includes(normal(name).replace(/\s/g,''))) return null;
      const override = config.overrides.find(value => [value.title,...String(value.aliases || '').split(',')].some(alias => normal(alias) === normal(name)));
      if (override?.visible === false) return null;
      const title = override?.title || name;
      return {id:normal(title),title,override};
    }
    const ranksFor = (product, character) => !isSharedPreview(product) || primaryCharacters.get(product.handle) === character.id;
    const previewOf = item => {
      const preferred = item.products.filter(product => ranksFor(product,item));
      const candidates = preferred.length ? preferred : item.products;
      return candidates.find(product => product.handle === item.hero) || candidates[0];
    };
    const choosePreviews = (items, query) => {
      const candidates = items.map(item => ({...item,preview:previewOf(item)}));
      const primaryPreviews = new Map();
      candidates.forEach(item => {
        if (isSharedPreview(item.preview) && ranksFor(item.preview,item)) primaryPreviews.set(item.preview.handle,item.id);
      });
      const seen = new Set();
      return candidates.filter(item => {
        if (query || !isSharedPreview(item.preview)) return true;
        const primary = primaryPreviews.get(item.preview.handle);
        if ((primary && primary !== item.id) || seen.has(item.preview.handle)) return false;
        seen.add(item.preview.handle);
        return true;
      });
    };
    function productLabel(product, character) {
      const names = character ? [character] : list(product.characters).map(raw => {
        const override = config.overrides.find(value => [value.title, ...String(value.aliases || '').split(',')].some(alias => normal(alias) === normal(raw)));
        return override?.title || String(raw).replace(/\([^)]*\)/g, '').trim();
      }).filter(name => name && !['fantasy/customkarakter', 'fantasy', 'customkarakter'].includes(normal(name).replace(/\s/g, '')));
      const uniqueNames = [...new Map(names.map(name => [normal(name), name])).values()];
      return uniqueNames.length ? uniqueNames.join(' / ') + ' – ' + product.title : product.title;
    }
    function modelOptionLabel(product, character) {
      const stories = [...new Set(list(product.stories).map(value => String(value).trim()).filter(Boolean))];
      const title = productLabel(product, character);
      return stories.length ? title + ' – ' + stories.join(' / ') : title;
    }
    const area = root.querySelector('[data-finder-choices]');
    const result = root.querySelector('[data-finder-result]');
    const tabs = [...root.querySelectorAll('[data-finder-tab]')];
    const input = root.querySelector('[data-finder-search]');
    const side = root.querySelector('[data-finder-side]');
    const status = root.querySelector('[data-finder-status]');
    const retry = root.querySelector('[data-finder-retry]');
    const all = root.querySelector('[data-finder-all]');
    const size = Number(root.dataset.pageSize) || 12;
    const sort = root.querySelector('[data-finder-sort]');
    const tools = root.querySelector('[data-finder-tools]');
    sort.value = root.dataset.sort || 'popular';
    let ranking = new Map();
    let popularityReady = false;
    const selected = {};
    let group = tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.finderTab || 'characters';
    let page = 0;
    let groups = {};
    let matches = [];
    let products = [];
    const isHelmet = product => list(product.collections).some(value => collectionKey(value) === 'helmen');
    function filteredUrl(key, values) {
      const url = new URL(config.sourceUrl, location.origin);
      url.searchParams.delete(key);
      [...new Set(values)].forEach(value => url.searchParams.append(key, value));
      return url.pathname + url.search;
    }
    function link(product, label, className) {
      const a = element('a', className, label || product.title);
      a.href = product.url;
      return a;
    }
    function details(items) {
      if (!items.length) return null;
      const detail = element('details', 'kenjo-finder__models');
      detail.append(element('summary', '', labels.related));
      const ul = element('ul');
      items.forEach(product => { const li = element('li'); li.append(link(product)); ul.append(li); });
      detail.append(ul);
      return detail;
    }
    function showCard(item) {
      result.replaceChildren();
      if (!item) return;
      selected[group] = item.id;
      [...area.children].forEach(button => button.setAttribute('aria-pressed', String(button.dataset.item === item.id)));
      const feature = element('div', 'kenjo-finder__feature');
      const visual = element('div', group === 'characters' ? 'kenjo-finder__photo' : 'kenjo-finder__story');
      const copy = element('div', 'kenjo-finder__copy');
      copy.append(element('p', 'kenjo-finder__eyebrow', group === 'characters' ? labels.character : labels[group]), element('h3', '', item.title));
      const description = item.description || (group === 'characters' ? (item.products.some(isHelmet) ? labels.productDescription : labels.characterDescription).replace('{character}', item.title) : labels.storyDescription);
      const intro = element('p', '', description);
      copy.append(intro);
      if (group === 'characters') {
        const picture = element('img'); picture.loading = 'lazy'; picture.width = 800; picture.height = 800;
        const caption = element('span', 'kenjo-finder__caption');
        visual.append(picture, caption);
        const cta = link(item.products[0], labels.cta, 'btn kenjo-finder__cta');
        const relatedHost = element('div');
        function chooseProduct(product) {
          const mini = String(product.miniDescription || '').trim();
          intro.textContent = config.useProductIntro !== false && mini ? mini : description;
          const image = product.handle === item.hero && item.image ? item.image : product.image;
          picture.hidden = !image; if (image) picture.src = image; picture.alt = product.title;
          caption.textContent = productLabel(product, item.title); cta.href = product.url; cta.textContent = isHelmet(product) ? labels.helmetCta : labels.cta;
          relatedHost.replaceChildren();
          const related = details(unique(list(product.related)).filter(value => String(value.id) !== String(product.id)));
          if (related) relatedHost.append(related);
        }
        if (item.products.length > 1) {
          const label = element('label', 'kenjo-finder__model');
          label.append(element('span', '', labels.choose));
          const select = element('select');
          item.products.forEach(product => { const option = element('option', '', modelOptionLabel(product, item.title)); option.value = String(product.id); select.append(option); });
          select.addEventListener('change', () => chooseProduct(item.products.find(product => String(product.id) === select.value)));
          const first = item.preview || previewOf(item);
          select.value = String(first.id); label.append(select); copy.append(label); chooseProduct(first);
        } else chooseProduct(item.preview || previewOf(item));
        copy.append(cta, relatedHost);
      } else {
        const code = group === 'films' ? roman[Number(item.episode)]?.toUpperCase() || item.title : item.title;
        visual.append(element('span', group === 'films' ? 'kenjo-finder__roman' : '', code));
        if (config.showStoryBadge && labels.storyBadge) visual.append(element('small', '', labels.storyBadge));
        const matchingStory = item.products.flatMap(product => list(product.stories)).find(value => storyMatch(item, {stories:[value]}));
        const target = { url: group === 'factions' ? item.url : matchingStory ? filteredUrl('filter.p.m.custom.film_serie', [matchingStory]) : item.url || config.sourceUrl };
        copy.append(link(target, labels.collectionCta, 'btn kenjo-finder__cta'));
        if (item.products.length) {
          const ul = element('ul', 'kenjo-finder__models-list');
          item.products.forEach(product => { const li = element('li'); li.append(link(product, productLabel(product))); ul.append(li); });
          const detail = element('details', 'kenjo-finder__models');
          detail.append(element('summary', '', labels.choose), ul); copy.append(detail);
        }
      }
      feature.append(visual, copy); result.append(feature);
    }
    function eligible(product) { return (!side.value || sideOf(product.side) === side.value); }
    function draw() {
      const query = normal(input.value);
      matches = (groups[group] || []).map(item => ({...item, products:item.products.filter(eligible)})).filter(item => item.products.length && (!query || normal(item.title+' '+(item.aliases || '').replace(/\([^)]*\)/g, '')+' '+item.products.map(product => product.title).join(' ')).includes(query)));
      if (group === 'characters') {
        const rank = item => {
          const ownModels = item.products.filter(product => ranksFor(product,item));
          return ownModels.length ? Math.min(...ownModels.map(product => ranking.get(String(product.id)) ?? Number.MAX_SAFE_INTEGER)) : Number.MAX_SAFE_INTEGER;
        };
        matches.sort(sort.value === 'popular' ? (a,b) => rank(a)-rank(b)||nameSort(a,b) : sort.value === 'reverse' ? (a,b) => nameSort(b,a) : nameSort);
      }
      // Keep every character searchable; the overview shows a shared model only once.
      const allMatches = matches;
      if (group === 'characters') {
        matches = choosePreviews(allMatches,query);
      }
      tools.hidden = group !== 'characters';
      sort.closest('.kenjo-finder__sort').hidden = group !== 'characters';
      root.dataset.finderGroup = group;
      root.querySelector('[data-finder-sort-status]').hidden = group !== 'characters' || popularityReady;
      const pages = Math.max(1, Math.ceil(matches.length / size));
      page = Math.min(Math.max(0, page), pages - 1);
      area.replaceChildren();
      const chosen = matches.find(item => item.id === selected[group]);
      matches.slice(page * size, (page + 1) * size).forEach(item => {
        const button = element('button', 'kenjo-finder__choice btn'); button.type = 'button'; button.dataset.item = item.id;
        button.setAttribute('aria-pressed', String(chosen?.id === item.id));
        if (group === 'characters') { const product = item.preview || previewOf(item); const src = item.image ? item.thumbnail || item.image : product.thumbnail || product.image; if (src) { const image = element('img'); image.src=src; image.alt=''; image.width=52; image.height=52; image.loading='lazy'; button.append(image); } }
        button.append(element('span', '', item.title)); button.addEventListener('click', () => showCard(item)); area.append(button);
      });
      root.querySelector('[data-finder-count]').textContent = matches.length ? `${page*size+1}–${Math.min((page+1)*size,matches.length)} / ${matches.length}` : '0';
      root.querySelector('[data-finder-empty]').hidden = matches.length > 0;
      root.querySelector('[data-finder-pagination]').hidden = matches.length <= size;
      root.querySelector('[data-finder-prev]').disabled = page === 0;
      root.querySelector('[data-finder-next]').disabled = page === pages - 1;
      all.hidden = group !== 'characters';
      input.closest('.kenjo-finder__search').hidden = group !== 'characters';
      const allList = root.querySelector('[data-finder-all-list]'); allList.replaceChildren();
      if (group === 'characters') allMatches.forEach(item => { const button=element('button','',item.title); button.type='button'; button.addEventListener('click',()=>{input.value=item.title;page=0;selected[group]=item.id;all.open=false;draw();});allList.append(button);});
      side.closest('.kenjo-finder__search').hidden = group === 'factions';
      tabs.forEach(tab => {const active=tab.dataset.finderTab===group;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
      root.querySelector('[data-finder-panel]').setAttribute('aria-labelledby',tabs.find(tab=>tab.dataset.finderTab===group).id);
      showCard(chosen);
    }
    function build() {
      const allowed = new Set(String(config.catalogCollections || '').split(/\r?\n/).map(collectionKey).filter(Boolean));
      products = unique(products).filter(product => !product.exclude && list(product.collections).some(value => allowed.has(collectionKey(value))));
      const characters = new Map();
      products.forEach(product => list(product.characters).forEach(raw => {
        const character = characterFor(raw);
        if (!character) return;
        const {id,title,override} = character;
        if (!characters.has(id)) characters.set(id,{id,title,aliases:override?.aliases||'',description:override?.description||'',hero:override?.hero,image:override?.image,thumbnail:override?.thumbnail,block:override?.id,products:[]});
        characters.get(id).products.push(product);
      }));
      sharedPreviews.clear();
      primaryCharacters.clear();
      if (config.sharedModelLogic !== false) {
        products.forEach(product => {
          if (isHelmet(product)) return;
          // Preserve metafield order after collapsing aliases into real character groups.
          const names = new Set(list(product.characters).map(characterFor).filter(Boolean).map(character => character.id));
          if (names.size > 1) {
            sharedPreviews.add(product.handle);
            primaryCharacters.set(product.handle,names.values().next().value);
          }
        });
      }
      const previewTier = product => list(product.collections).some(value => collectionKey(value) === 'legendary sabers') ? 0 : isHelmet(product) ? 2 : 1;
      groups.characters=[...characters.values()].map(item=>({...item,products:unique(item.products).sort((a,b)=>Number(b.available)-Number(a.available)||(config.preferLegendary !== false ? previewTier(a)-previewTier(b) : 0)||(ranking.get(String(a.id)) ?? Number.MAX_SAFE_INTEGER)-(ranking.get(String(b.id)) ?? Number.MAX_SAFE_INTEGER)||nameSort(a,b))})).sort(nameSort);
      for (const key of ['films','series','games']) groups[key]=config.stories.filter(story=>story.group===key).map(story=>({...story,id:story.handle,products:products.filter(product=>storyMatch(story,product)).sort(nameSort)}));
      groups.factions=['light','dark','other','custom'].map(key=>({id:key,title:labels[key],description:config.factionDescriptions[key],products:products.filter(product=>sideOf(product.side)===key).sort(nameSort),url:filteredUrl('filter.p.m.custom.karakter_ge_nspireerd_', products.filter(product=>sideOf(product.side)===key).map(product=>product.side))}));
      status.hidden=true; retry.hidden=true; draw();
    }
    async function loadRanking() {
      try {
        const ids = [];
        const seen = new Set();
        let next = new URL(config.rankingUrl, location.origin);
        next.searchParams.set('sort_by', 'best-selling');
        while (next) {
          next.searchParams.set('section_id', 'kenjo-saber-finder');
          if (seen.has(next.href)) throw new Error('Repeated ranking page');
          seen.add(next.href);
          const batch = await readPage(next, '[data-finder-ranking]', 10000); ids.push(...batch.ids);
          next = batch.next ? new URL(batch.next, next) : null;
          if (next) next.searchParams.set('sort_by', 'best-selling');
        }
        if (!ids.length) throw new Error('Ranking empty');
        ranking = new Map(ids.map((id,index) => [String(id),index]));
        popularityReady = true;
      } catch {
        popularityReady = false;
        if (sort.value === 'popular') sort.value = 'alphabetical';
      }
      sort.querySelector('[value="popular"]').disabled = !popularityReady;
    }
    async function load() {
      try {
        products=[];status.hidden=false;retry.hidden=true;
        const seen = new Set();
        let next = new URL(config.catalogUrl, location.origin);
        next.searchParams.set('sort_by', 'best-selling');
        while (next) {
          next.searchParams.set('section_id', 'kenjo-saber-finder');
          if (seen.has(next.href)) throw new Error('Repeated catalog page');
          seen.add(next.href);
          const batch = await readPage(next, '[data-finder-products]', 15000);
          products.push(...batch.products);
          next = batch.next ? new URL(batch.next, next) : null;
          if (next) next.searchParams.set('sort_by', 'best-selling');
        }
        ranking = new Map(products.map((product,index) => [String(product.id),index]));
        popularityReady = true;
        if (config.rankingUrl && new URL(config.rankingUrl, location.origin).pathname !== new URL(config.catalogUrl, location.origin).pathname) await loadRanking();
        sort.querySelector('[value="popular"]').disabled = !popularityReady;
        build();
      } catch { status.textContent=labels.error;status.hidden=false;retry.hidden=false;area.replaceChildren();result.replaceChildren(); }
    }
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>{group=tab.dataset.finderTab;page=0;input.value='';if(group==='factions')side.value='';draw();});
      tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length;tabs[next].focus();tabs[next].click();});
    });
    sort.addEventListener('change',()=>{page=0;delete selected.characters;all.open=false;draw();});
    [input,side].forEach(control=>control.addEventListener(control===input?'input':'change',()=>{page=0;draw();}));
    root.querySelector('[data-finder-prev]').addEventListener('click',()=>{page--;draw();});
    root.querySelector('[data-finder-next]').addEventListener('click',()=>{page++;draw();});
    retry.addEventListener('click',load);
    root.addEventListener('shopify:block:select',event=>{const item=groups.characters?.find(value=>value.block===event.detail.blockId);if(item){group='characters';input.value=item.title;side.value='';selected[group]=item.id;page=0;draw();}});
    await load();
  }
  function scan(scope) {scope.querySelectorAll('[data-kenjo-finder]').forEach(init);}
  scan(document);
  if(!window.kenjoFinderListener){window.kenjoFinderListener=true;document.addEventListener('shopify:section:load',event=>scan(event.target));}
})();








